/* eslint-disable no-param-reassign */
/**
 * 通用工具类
 */
/**
 * buildingCode的格式化方法
 * @param buildingCode
 * @returns {string}
 */
import { getCustomDicts } from '@/components/components/utils'
import store from '../store'
import { deepClone } from './util'

export default class func {
  /**
   * 不为空
   * @param val
   * @returns {boolean}
   */
  static notEmpty(val) {
    return !this.isEmpty(val)
  }

  /**
   * 是否为定义
   * @param val
   * @returns {boolean}
   */
  static isUndefined(val) {
    return val === null || typeof val === 'undefined'
  }

  /**
   * 为空
   * @param val
   * @returns {boolean}
   */
  static isEmpty(val) {
    if (
      val === null
      || typeof val === 'undefined'
      || (typeof val === 'string' && val === '' && val !== 'undefined')
    ) {
      return true
    }
    return false
  }

  /**
   * 强转int型
   * @param val
   * @param defaultValue
   * @returns {number}
   */
  static toInt(val, defaultValue) {
    if (this.isEmpty(val)) {
      return defaultValue === undefined ? -1 : defaultValue
    }
    const num = parseInt(val, 0)
    const hasVal = (defaultValue === undefined ? -1 : defaultValue)
    return Number.isNaN(num) ? hasVal : num
  }

  /**
   * Json强转为Form类型
   * @param obj
   * @returns {FormData}
   */
  static toFormData(obj) {
    const data = new FormData()
    Object.keys(obj).forEach(key => {
      data.append(key, Array.isArray(obj[key]) ? obj[key].join(',') : obj[key])
    })
    return data
  }

  /**
   * date类转为字符串格式
   * @param date
   * @param format
   * @returns {null}
   */
  static format(date, format = 'YYYY-MM-DD HH:mm:ss') {
    return date ? date.format(format) : null
  }

  /**
   * 根据逗号联合
   * @param arr
   * @returns {string}
   */
  static join(arr) {
    return arr ? arr.join(',') : ''
  }

  /**
   * 根据逗号分隔
   * @param str
   * @returns {string}
   */
  static split(str) {
    return str ? String(str).split(',') : ''
  }
}

export function getListToTree(list) {
  const map = {}; let node; const tree = []; let i
  for (i = 0; i < list.length; i += 1) {
    map[list[i].value] = list[i]
    list[i].children = []
  }
  for (i = 0; i < list.length; i += 1) {
    node = list[i]
    if (node.parentID !== '0' && map[node.parentID]) {
      map[node.parentID].children.push(node)
    } else {
      tree.push(node)
    }
  }
  return tree
}

/**
   * base64转为图片文件
   * @param urlData
   * @returns
   */
export function base64ToBlob(urlData) {
  const arr = urlData.split(',')
  const mime = arr[0].match(/:(.*?);/)[1] || 'image/png'
  // 去掉url的头，并转化为byte
  const bytes = window.atob(arr[1])
  // 处理异常,将ascii码小于0的转换为大于0
  const ab = new ArrayBuffer(bytes.length)
  // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
  const ia = new Uint8Array(ab)

  for (let i = 0; i < bytes.length; i += 1) {
    ia[i] = bytes.charCodeAt(i)
  }

  return new Blob([ab], {
    type: mime,
  })
}

export const formatBuildingCode = str => {
  if (!str) return ''
  const roomTypeMap = store.getters.roomType
  const strArr = str.split('-')
  let reStr = ''
  switch (strArr.length) {
    case 2:
      reStr = [...strArr[1]]
      break
    case 3:
      reStr = `${strArr[1]} L-${strArr[2]}`
      break
    case 4:
      reStr = `${strArr[1]} #${strArr[2]}-${strArr[3]}`
      break
    case 5:
      reStr = `${strArr[1]} #${strArr[2]}-${strArr[3]} ${roomTypeMap[strArr[4]].roomName}` || strArr[4]
      break
    default:
  }
  return reStr
}

/**
 * 将数组按长度分组为二维数组
 * @param {Array} array 源坐标
 * @param {Number} groupLength 数组分组长度
 * @returns {Array} 分组后的二维数组
 */
export const arrayGroup = (array, groupLength) => {
  let index = 0
  const newArray = []

  while (index < array.length) {
    newArray.push(array.slice(index, index += groupLength))
  }

  return newArray
}

/**
 * 驼峰命名
 * @param {Array} name 源数据
 * @returns {Array} 格式化之后数据
 */
// eslint-disable-next-line no-useless-escape
export const toHump = name => name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase());

/**
 * 排序
 * @param {Array} key 键值
 * @returns {Array} 排序之后
 */
// eslint-disable-next-line no-useless-escape
export const compare = key => (a, b) => {
  const value1 = a[key];
  const value2 = b[key];
  return value2 - value1;
}

// 需要修改的文件字段 待优化
/**
 * 映射字段： 表单字段
 */
const fields = {
  files: 'fileIds',
  tickets: 'ticketIds',
  photoFiles: 'photo',
  signAttach: 'sign',
  confirmFileFiles: 'confirmFile',
  latestPayslipFiles: 'latestPayslip',
  trainingCertificateFiles: 'trainingCertificate',
  highestQualificationCertFiles: 'highestQualificationCert',
  nricFileFiles: 'nricFile',
}

/**
 * 自定义表单数据格式化成option
 * @param {Array} array 数据库返回数据
 * @param {Array} setDictQuery 设置dict查询条件
 * @returns {Array} 格式化之后的option
 */

export const templateFormat = (array, setDictQuery = () => { }) => {
  console.log(array, 'array')
  const hideType = ['title', 'info']
  const res = []
  if (Array.isArray(array)) {
    array.forEach(item => {
      let field = ''
      Object.keys(fields).forEach(fieldF => {
        const itemF = fields[fieldF];
        if (item.fieldName === itemF) {
          field = fieldF
        }
      })
      if (!field) {
        field = item.fieldName// toHump(item.fieldName)
      }
      const params = {
        label: item.fieldLabel,
        field,
        type: item.fieldType,
        sort: item.sort,
        hide: hideType.indexOf(item.fieldType) !== -1,
        search: item.search === 1,
        searchBase: item.search === 1,
        multiple: item.formatOption?.multipleSearch || false,

        formOption: {
          rules: item.required === 1 ? 'required' : '',
          type: item.fieldType,
          span: item.span,
          dictQuery: setDictQuery(item),
          placeholder: item.placeholder,
          formEditDisabled: item.formEditDisabled,
        },
      }

      if (getCustomDicts[item.dictCode]) {
        params.dictCode = item.dictCode
        params.formOption.dictCode = item.dictCode
      } else {
        params.dictBizCode = item.dictCode
        params.formOption.dictBizCode = item.dictCode
      }

      if (item.fieldOption) {
        const option = JSON.parse(item.fieldOption)
        Object.entries(option).forEach(key => {
          params.formOption[key[0]] = deepClone(key[1])
        })
        // params.formOption.dictData = option.dictData
      }

      if (item.dictCode || params.formOption.useDictName) {
        const dictField = `${field}Name`
        if (field.indexOf('Id') !== -1) {
          params.dictField = `${field.replace('Id', 'Name')}`
        } else if (dictField) {
          params.dictField = `${field}Name`
        }
      }
      if (field === 'files') {
        params.hide = true
        params.columnHide = true
      }

      if (item.defaultValue) {
        let db = item.defaultValue
        if (item.defaultValue.startsWith('$')) {
          params.funcValue = item.defaultValue
          const defaultValueParams = item.defaultValue.match(/{(\S*)}/)[1];
          const defaultValueParamsKeys = defaultValueParams.split('.') || []
          defaultValueParamsKeys.forEach((key, index) => {
            if (index === 0) {
              switch (key) {
                case 'store':
                  db = store.getters
                  break;
                default:
                  db = {}
                  break;
              }
            } else {
              db = db[key] || (defaultValueParamsKeys.length - 1 === index ? '' : {})
            }
          })
        }
        if (db && db !== -1) {
          params.formOption.value = db
          params.value = db
        }
      }
      if (item.fieldType === 'date') {
        params.dateInputFormat = 'yyyy-MM-dd'
        params.dateOutputFormat = 'yyyy-MM-dd'
      }
      if (item.fieldType === 'dateTime') {
        params.dateInputFormat = 'yyyy-MM-dd hh:mm:ss'
        params.dateOutputFormat = 'MMM do yy'
      }
      res.push(params)
    })
  }
  const filterField = [
    'assigneeList',
    'assignees',
    'firstApprover',
  ]
  // 判断是否是多部门员工
  if (store.getters.userAllInfo?.roleAlias?.indexOf('multiple_dept_user') !== -1 && !res.find(o => filterField.includes(o.field))) {
    res.push(
      {
        label: 'Approver',
        field: 'firstApprover',
        fieldDict: 'firstApproverName',
        sort: 9999999,
        formOption: {
          type: 'select',
          dictCode: 'staff',
          rules: 'required',
          viewHide: true,
          value: store.getters.userAllInfo?.staffInfo?.firstApprover,
        },
      },
    )
  }
  return res.sort(compare('sort'))
}
export const templateFormatNew = (array, setDictQuery = () => { }) => {
  const hideType = ['title', 'info']
  const res = []
  if (Array.isArray(array)) {
    array.forEach(item => {
      let field = ''
      Object.keys(fields).forEach(fieldF => {
        const itemF = fields[fieldF];
        if (item.fieldName === itemF) {
          field = fieldF
        }
      })
      if (!field) {
        field = item.fieldName// toHump(item.fieldName)
      }
      const params = {
        label: item.fieldLabel,
        field,
        type: item.fieldType,
        sort: item.sort,
        hide: item.hide,
        search: item.search === 1,
        searchBase: item.search === 1,
        formOption: {
          rules: item.required === 1 ? 'required' : '',
          type: item.fieldType,
          span: item.span,
          dictQuery: setDictQuery(item),
          placeholder: item.placeholder,
          formEditDisabled: item.formEditDisabled,
        },
      }

      if (getCustomDicts[item.dictCode]) {
        params.dictCode = item.dictCode
        params.formOption.dictCode = item.dictCode
      } else {
        params.dictBizCode = item.dictCode
        params.formOption.dictBizCode = item.dictCode
      }

      if (item.fieldOption) {
        const option = JSON.parse(item.fieldOption)
        Object.entries(option).forEach(key => {
          params.formOption[key[0]] = deepClone(key[1])
        })
        // params.formOption.dictData = option.dictData
      }

      if (item.dictCode || params.formOption.useDictName) {
        const dictField = `${field}Name`
        if (field.indexOf('Id') !== -1) {
          params.dictField = `${field.replace('Id', 'Name')}`
        } else if (dictField) {
          params.dictField = `${field}Name`
        }
      }
      if (field === 'files') {
        params.hide = true
        params.columnHide = true
      }

      if (item.defaultValue) {
        let db = item.defaultValue
        if (item.defaultValue.startsWith('$')) {
          params.funcValue = item.defaultValue
          const defaultValueParams = item.defaultValue.match(/{(\S*)}/)[1];
          const defaultValueParamsKeys = defaultValueParams.split('.') || []
          defaultValueParamsKeys.forEach((key, index) => {
            if (index === 0) {
              switch (key) {
                case 'store':
                  db = store.getters
                  break;
                default:
                  db = {}
                  break;
              }
            } else {
              db = db[key] || (defaultValueParamsKeys.length - 1 === index ? '' : {})
            }
          })
        }
        if (db && db !== -1) {
          params.formOption.value = db
          params.value = db
        }
      }
      if (item.fieldType === 'date') {
        params.dateInputFormat = 'yyyy-MM-dd'
        params.dateOutputFormat = 'yyyy-MM-dd'
      }
      if (item.fieldType === 'dateTime') {
        params.dateInputFormat = 'yyyy-MM-dd hh:mm:ss'
        params.dateOutputFormat = 'MMM do yy'
      }
      res.push(params)
    })
  }
  const filterField = [
    'assigneeList',
    'assignees',
    'firstApprover',
  ]
  // 判断是否是多部门员工
  if (store.getters.userAllInfo?.roleAlias?.indexOf('multiple_dept_user') !== -1 && !res.find(o => filterField.includes(o.field))) {
    res.push(
      {
        label: 'Approver',
        field: 'firstApprover',
        fieldDict: 'firstApproverName',
        sort: 9999999,
        formOption: {
          type: 'select',
          dictCode: 'staff',
          rules: 'required',
          viewHide: true,
          value: store.getters.userAllInfo?.staffInfo?.firstApprover,
        },
      },
    )
  }
  return res.sort(compare('sort'))
}
/**
 * 编辑回填：将 fileIds 等接口字段转为上传组件所需的 files 数组
 */
export const normalizeTemplateUploadData = (data, columns) => {
  if (!data || !Array.isArray(columns)) return data
  columns.filter((o) => o.type === 'upload').forEach((col) => {
    const formField = col.field
    const apiField = fields[formField] || formField
    const normalizeFile = (file) => {
      const id = file.attachId || file.id
      return { ...file, id, attachId: id }
    }
    if (Array.isArray(data[formField]) && data[formField].length > 0) {
      data[formField] = data[formField].map(normalizeFile)
    } else if (data[apiField]) {
      const raw = data[apiField]
      let ids = []
      if (typeof raw === 'string') {
        ids = raw.split(',').filter(Boolean)
      } else if (Array.isArray(raw)) {
        ids = raw.map((o) => (typeof o === 'object' ? o.attachId || o.id : o)).filter(Boolean)
      }
      data[formField] = ids.map((id) => ({ id, attachId: id }))
    } else if (!Array.isArray(data[formField])) {
      data[formField] = []
    }
  })
  return data
}

const mapUploadFileIds = (list) => list
  .map((o) => {
    if (o == null) return ''
    if (typeof o === 'object') {
      const id = o.attachId || o.id
      return Array.isArray(id) ? id.join() : id
    }
    return o
  })
  .filter((id) => id != null && id !== '')
  .join()

/**
 * 自定义表单提交数据格式化成option
 * @param {Array} form 数据
 * @returns {Array} 格式化之后的数据
 */

export const templateSubmitFormat = (form, columns) => {
  const params = deepClone(form)
  const findUploads = columns.filter(o => o.type === 'upload')
  findUploads.forEach(findUpload => {
    const isMapped = Object.prototype.hasOwnProperty.call(fields, findUpload.field)
    let key = findUpload.field
    if (isMapped) {
      key = fields[findUpload.field]
    }
    if (isMapped) {
      if (Array.isArray(params[findUpload.field])) {
        params[key] = mapUploadFileIds(params[findUpload.field])
      } else {
        params[key] = ''
      }
      delete params[findUpload.field]
    } else if (Array.isArray(params[findUpload.field])) {
      params[key] = mapUploadFileIds(params[findUpload.field])
    } else if (typeof params[findUpload.field] === 'object' && params[findUpload.field]) {
      params[key] = params[findUpload.field].attachId || params[findUpload.field].id
    }
  })

  const findMultipleT = columns.filter(o => (o.formOption && ['select', 'checkbox'].indexOf(o.type) !== -1))
  const findMultiple = findMultipleT.filter(o => (o.formOption.multiple || o.type === 'checkbox'))
  findMultiple.forEach(item => {
    const key = item.field
    if (Array.isArray(params[key])) {
      params[key] = params[key].join()
    }
  })

  return params
}

/**
 * option格式化成自定义表单数据
 * @param {Array} columns option-columns
 * @returns {Array} 格式化之后的自定义表单数据
 */

export const optionFormat = columns => {
  const cols = deepClone(columns)
  if (!Array.isArray(cols)) { return [] }
  const res = []
  const sort = 10000
  cols.forEach((item, i) => {
    if (item.funcValue) {
      item.formOption.value = item.funcValue
    }
    delete item.funcValue
    const formOption = item.formOption || {}
    const param = item
    param.fieldLabel = item.label
    param.fieldName = fields[item.field] ? fields[item.field] : item.field
    param.fieldType = formOption.type
    param.defaultValue = formOption.value
    param.required = formOption.rules === 'required' ? 1 : ''
    param.placeholder = formOption.placeholder
    param.span = formOption.span || 12
    param.dictCode = formOption.dictBizCode || formOption.dictCode
    param.sort = sort - i
    param.fieldOption = JSON.stringify(formOption)
    param.search = item.search ? 1 : 0

    res.push(param)
  })
  return res
}

/**
 * 流程历史数据格式化
 * @param {Array} data 数据
 * @returns {Array} 格式化之后的数据
 */

export const formatprocessHistoryData = (data = []) => {
  const res = []
  const resTemp = []
  const temp = data
  temp.sort((a, b) => {
    if (!b.endTime) {
      return -1
    }
    if (!a.endTime) {
      return 1
    }
    return (b.endTime > a.endTime ? -1 : 1)
  })
  temp.forEach((item, i) => {
    let title = ''
    let variant = 'primary'
    if (i === 0) {
      title = 'OA CREATE'
    } else if (i === data.length - 1 && !item.historyActivityName && data.length > 2) {
      title = 'OA END'
    } else {
      title = `${item.historyActivityName}`
    }
    const tip = `Start Time ${item.createTime} - End Time ${item.endTime}`
    let info = ''
    // let info = `(${item.assigneeAccount})${item.assigneeName}`
    if (item.assigneeAccount) {
      info = `(${item.assigneeAccount})${item.assigneeName}`
    } else {
      info = `${item.assigneeName}`
    }
    const remark = `Remarks: ${item.comment}`
    if (!item.historyActivityDurationTime && i > 0) {
      if (title !== 'OA END') {
        variant = 'secondary'
      }
    }
    if (i > 0 && item.historyActivityDurationTime) {
      if (!item.pass) {
        variant = 'danger'
      }
    }
    resTemp.push(
      {
        title,
        tip,
        info,
        remark,
        variant,
      },
    )
  })

  resTemp.forEach(item => {
    if (item.variant === 'secondary') {
      const find = res.find(o => (o.title === item.title && o.variant === 'secondary'))
      if (!find) {
        res.push(item)
      } else {
        const index = res.findIndex(o => (o.title === item.title && o.variant === 'secondary'))
        res[index] = {
          title: find.title,
          tip: find.tip,
          info: `${item.info}${find.info ? `, ${find.info}` : ''}`,
          remark: find.remark,
          variant: find.variant,
        }
      }
    } else {
      res.push(item)
    }
  })
  return res
}
